// Generated by purs version 0.13.0
"use strict";
var Ritoppu_Model_Equipment = require("../Ritoppu.Model.Equipment/index.js");
var Ritoppu_Model_Inventory = require("../Ritoppu.Model.Inventory/index.js");
var Ritoppu_Model_Level = require("../Ritoppu.Model.Level/index.js");
var initPlayer = {
    pos: {
        x: 0,
        y: 0
    },
    stats: {
        maxHp: 100,
        hp: 100,
        defense: 1,
        power: 4
    },
    turn: 0,
    inventory: Ritoppu_Model_Inventory.initInventory,
    level: Ritoppu_Model_Level.initLevel,
    equipment: Ritoppu_Model_Equipment.initEquipment
};
module.exports = {
    initPlayer: initPlayer
};
